import { BuilderChatContext, IWorkflowTemplateVersion } from '@commenda/types';
import { TBuilderChatSelection, TBuilderOpenTab } from './types/types';

/** Builds the note the agent is given about what is on the author's screen.
 *
 * One function so the pill above the composer and the request body can never disagree: what the author
 * is shown is literally what is sent. Returns null when the host supplies no tab, which is how the admin
 * builder sends nothing and stays exactly as it was. */
export class BuilderChatContextHelper {
  static build(params: {
    openTab: TBuilderOpenTab | undefined;
    selection: TBuilderChatSelection | null;
    version: IWorkflowTemplateVersion | null;
    isEditable: boolean;
  }): BuilderChatContext | null {
    const { openTab, selection, version, isEditable } = params;
    if (!openTab?.openTab) return null;

    return {
      openTab: openTab.openTab,
      ...(openTab.openFormName ? { openFormName: openTab.openFormName } : {}),
      ...(version?.workflowTemplate?.name
        ? { workflowName: version.workflowTemplate.name }
        : {}),
      ...(version?.version ? { versionLabel: version.version } : {}),
      isEditable,
      ...(selection
        ? {
            selectedNode: {
              id: selection.id,
              stepType: selection.stepType,
              name: selection.name,
            },
            ...(selection.otherSelectedCount > 0
              ? { otherSelectedCount: selection.otherSelectedCount }
              : {}),
          }
        : {}),
    };
  }

  /** What the pill reads. Kept beside build() so the wording follows the payload. */
  static describe(context: BuilderChatContext | null): string | null {
    if (!context) return null;
    if (context.selectedNode)
      return context.selectedNode.name || 'Selected step';
    if (context.openFormName) return context.openFormName;

    return context.workflowName ?? 'This workflow';
  }
}
